export default "__VITE_ASSET__CkZ221c9__"